import React from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../Services/supabaseClient';
import { NavLink } from 'react-router-dom';
import styles from './Sidebar.module.css';

export default function Sidebar() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    localStorage.removeItem('a_access_token');
    navigate('/login');
    window.location.reload();
  };

  return (
    <div className={styles.sidebar}>
      <h2 className={styles.logo}>Admin</h2>
      <nav className={styles.nav}>
        <NavLink to="/dashboard" className={({ isActive }) => isActive ? styles.active : ''}>Dashboard</NavLink>
        <NavLink to="/prices" className={({ isActive }) => isActive ? styles.active : ''}>Prices</NavLink>
        <NavLink to="/legal-documents" className={({ isActive }) => isActive ? styles.active : ''}>Legal Documents</NavLink>
        <NavLink to="/users" className={({ isActive }) => isActive ? styles.active : ''}>Users</NavLink>
        <NavLink to="/photographers" className={({ isActive }) => isActive ? styles.active : ''}>Photographers</NavLink>
        <NavLink to="/events" className={({ isActive }) => isActive ? styles.active : ''}>Events</NavLink>
        <NavLink to="/photos" className={({ isActive }) => isActive ? styles.active : ''}>Photos</NavLink>
        <NavLink to="/survey" className={({ isActive }) => isActive ? styles.active : ''}>Survey</NavLink>
      </nav>
      <button onClick={handleLogout} className={styles.logoutBtn}>Logout</button>
    </div>
  );
}
